/* ------------------------------------------------------------
   Plant Pot Configurator
   Bouwt per gekozen aantal potten een rij met formaat + patroon,
   berekent live de totaalprijs en voegt alles als losse regels
   toe aan de Shopify winkelwagen via de Ajax Cart API.

   Het patroon-veld is een eigen (custom) dropdown i.p.v. een
   normale <select>, omdat een normale <select> geen afbeeldingen
   in de opties kan tonen. Zo werkt de patroonkiezer wel als een
   dropdown, maar met een plaatje in zowel de gesloten balk als
   de open lijst.
------------------------------------------------------------ */
(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }

  function initConfigurator(root) {
    if (root.getAttribute('data-ppc-initialized') === 'true') return;
    root.setAttribute('data-ppc-initialized', 'true');

    var configEl = root.querySelector('.ppc-config');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('Plant Pot Configurator: could not read configuration.', e);
      return;
    }

    var potCountSelect = root.querySelector('.ppc-pot-count');
    var potsWrap = root.querySelector('.ppc-pots');
    var ownPriceEl = root.querySelector('.ppc-summary-price');
    var priceWarningEl = root.querySelector('.ppc-price-warning');
    var addBtn = root.querySelector('.ppc-add-btn');
    var feedbackEl = root.querySelector('.ppc-feedback');

    function sizeOptionsHtml() {
      return config.sizes
        .map(function (size) {
          return (
            '<option value="' + size.id + '" data-price="' + size.price + '">' +
            size.title +
            '</option>'
          );
        })
        .join('');
    }

    function patternMenuHtml() {
      return config.patterns
        .map(function (pattern, index) {
          return (
            '<li class="ppc-pattern-option" role="option" data-index="' + index + '" aria-selected="' + (index === 0 ? 'true' : 'false') + '">' +
              '<span class="ppc-pattern-thumb"><img src="' + (pattern.image || '') + '" alt="" loading="lazy"></span>' +
              '<span class="ppc-pattern-option-label">' + pattern.label + '</span>' +
            '</li>'
          );
        })
        .join('');
    }

    function patternPickerHtml(potIndex) {
      var first = config.patterns[0] || { label: '', image: '' };
      return (
        '<div class="ppc-pattern-picker" data-selected-index="0">' +
          '<button type="button" class="ppc-pattern-trigger" aria-haspopup="listbox" aria-expanded="false" aria-label="Pattern for pot ' + potIndex + '">' +
            '<span class="ppc-pattern-thumb"><img src="' + (first.image || '') + '" alt="" loading="lazy"></span>' +
            '<span class="ppc-pattern-trigger-label">' + first.label + '</span>' +
            '<svg class="ppc-pattern-caret" viewBox="0 0 12 8" width="12" height="8" aria-hidden="true">' +
              '<path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</button>' +
          '<ul class="ppc-pattern-menu" role="listbox" hidden>' + patternMenuHtml() + '</ul>' +
        '</div>'
      );
    }

    function renderRows(count) {
      var html = '';
      for (var i = 1; i <= count; i++) {
        html +=
          '<div class="ppc-pot-row" data-pot="' + i + '">' +
            '<span class="ppc-pot-index">Pot ' + i + '</span>' +
            '<div class="ppc-select-wrap">' +
              '<select class="ppc-select ppc-size-select" aria-label="Size for pot ' + i + '">' +
                sizeOptionsHtml() +
              '</select>' +
            '</div>' +
            patternPickerHtml(i) +
          '</div>';
      }
      potsWrap.innerHTML = html;
      updateTotal();
    }

    function closeAllPatternMenus() {
      root.querySelectorAll('.ppc-pattern-menu').forEach(function (menu) {
        menu.hidden = true;
        var trigger = menu.previousElementSibling;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function selectPattern(picker, index) {
      var pattern = config.patterns[index];
      if (!pattern) return;

      picker.setAttribute('data-selected-index', index);

      var thumbImg = picker.querySelector('.ppc-pattern-trigger .ppc-pattern-thumb img');
      var label = picker.querySelector('.ppc-pattern-trigger-label');
      if (thumbImg) thumbImg.src = pattern.image || '';
      if (label) label.textContent = pattern.label;

      picker.querySelectorAll('.ppc-pattern-option').forEach(function (option) {
        var isSelected = option.getAttribute('data-index') === String(index);
        option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    var FALLBACK_PRICE_SELECTORS = [
      '.price__regular:not(.price__hidden) .price, .price__sale:not(.price__hidden) .price',
      '.price .price-item--regular, .price .price-item--sale'
    ];

    function findPriceElement() {
      var candidates = [];
      if (config.priceSelector) candidates.push(config.priceSelector);
      FALLBACK_PRICE_SELECTORS.forEach(function (selector) {
        if (candidates.indexOf(selector) === -1) candidates.push(selector);
      });

      for (var i = 0; i < candidates.length; i++) {
        var el = document.querySelector(candidates[i]);
        if (el) return el;
      }
      return null;
    }

    var currentTotalFormatted = null;

    function updateTotal() {
      var total = config.basePrice || 0;
      root.querySelectorAll('.ppc-size-select').forEach(function (select) {
        var opt = select.options[select.selectedIndex];
        var price = opt ? parseInt(opt.getAttribute('data-price'), 10) : 0;
        total += isNaN(price) ? 0 : price;
      });
      currentTotalFormatted = formatMoney(total);

      // Onze eigen prijsregel: deze staat volledig onder onze controle
      // en werkt dus altijd, ongeacht hoe het thema zijn eigen prijs
      // rendert of ververst.
      if (ownPriceEl) ownPriceEl.textContent = currentTotalFormatted;

      // Bonus: probeer ook de prijs bovenaan de pagina (van het thema
      // zelf) te syncen. Lukt dit niet of wordt het overschreven, dan
      // blijft de eigen prijsregel hierboven altijd correct.
      applyThemePrice();
    }

    function applyThemePrice() {
      if (currentTotalFormatted === null) return;
      var priceEl = findPriceElement();

      if (priceEl) {
        if (priceEl.textContent.trim() !== currentTotalFormatted) {
          priceEl.textContent = currentTotalFormatted;
        }
        if (priceWarningEl) priceWarningEl.hidden = true;
      } else if (window.Shopify && window.Shopify.designMode && priceWarningEl) {
        priceWarningEl.hidden = false;
      }
    }

    // Sommige thema's renderen hun prijs-element opnieuw (bijv. bij het
    // laden van de pagina, of via een eigen component). Deze observer
    // zet onze totaalprijs meteen terug zodra dat gebeurt.
    var priceObserver = new MutationObserver(function () {
      applyThemePrice();
    });
    priceObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

    function setFeedback(message, isError) {
      feedbackEl.textContent = message;
      feedbackEl.classList.toggle('ppc-feedback-error', !!isError);
    }

    function generateBundleId() {
      return 'ppc-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    }

    function addToCart() {
      var rows = root.querySelectorAll('.ppc-pot-row');
      if (!rows.length || !config.baseVariantId) {
        setFeedback('Something went wrong: no product found.', true);
        return;
      }

      var bundleId = generateBundleId();

        var items = [];

      // Geen aparte basisregel wanneer de formaat-toeslag naar het product
      // zelf wijst (baseVariantId is dan null vanuit de Liquid-config) —
      // de pot-regel hieronder bevat dan al de juiste variant/prijs.
      if (config.baseVariantId) {
        items.push({
          id: config.baseVariantId,
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_role: 'base'
          }
        });
      }
      rows.forEach(function (row) {
        var potIndex = row.getAttribute('data-pot');
        var sizeSelect = row.querySelector('.ppc-size-select');
        var sizeOpt = sizeSelect.options[sizeSelect.selectedIndex];
        var patternPicker = row.querySelector('.ppc-pattern-picker');
        var patternIndex = patternPicker ? parseInt(patternPicker.getAttribute('data-selected-index'), 10) : 0;
        var pattern = config.patterns[patternIndex];

        if (!sizeOpt) return;

        items.push({
          id: parseInt(sizeSelect.value, 10),
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_role: 'pot',
            Pot: potIndex,
            Size: sizeOpt.textContent,
            Pattern: pattern ? pattern.label : ''
          }
        });
      });

      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      setFeedback('', false);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              return Promise.reject(err);
            });
          }
          return response.json();
        })
        .then(function () {
          setFeedback('Added to your cart!', false);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('Plant Pot Configurator - error adding to cart:', err);
          setFeedback((err && err.description) || 'Something went wrong, please try again.', true);
        })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to cart';
        });
    }

    potCountSelect.addEventListener('change', function (e) {
      renderRows(parseInt(e.target.value, 10));
    });

    potsWrap.addEventListener('change', function (e) {
      if (e.target.classList.contains('ppc-size-select')) {
        updateTotal();
      }
    });

    potsWrap.addEventListener('click', function (e) {
      var trigger = e.target.closest('.ppc-pattern-trigger');
      var option = e.target.closest('.ppc-pattern-option');

      if (trigger) {
        var picker = trigger.closest('.ppc-pattern-picker');
        var menu = picker.querySelector('.ppc-pattern-menu');
        var isOpen = !menu.hidden;
        closeAllPatternMenus();
        if (!isOpen) {
          menu.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      if (option) {
        var optionPicker = option.closest('.ppc-pattern-picker');
        var index = parseInt(option.getAttribute('data-index'), 10);
        selectPattern(optionPicker, index);
        closeAllPatternMenus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target) || !e.target.closest('.ppc-pattern-picker')) {
        closeAllPatternMenus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPatternMenus();
    });

    addBtn.addEventListener('click', addToCart);

    renderRows(parseInt(potCountSelect.value, 10));
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.ppc').forEach(initConfigurator);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // De Shopify Theme Editor herlaadt secties/blocks live zodra je een
  // instelling aanpast. Dat vervangt de HTML zonder de <script> opnieuw
  // uit te voeren, waardoor de configurator "dood" kan lijken in de
  // editor-preview. Deze listener initialiseert 'm dan opnieuw. Op de
  // echte (live) winkel gebeurt dit niet, daar is dit niet nodig.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();